<template>
  <div>
    <vue-editor v-if="!disableButton"
      v-model="content"
    ></vue-editor>
    <div v-if="disableButton" v-html="content"></div>
    <div class="center">
      <v-btn
        v-if="!disableButton"
        color="primary"
        dark
        class="mb-2"
        @click="handleSavingContent"
      >
        Save Content
      </v-btn>
    </div>
  </div>
</template>

</template>
<script>

import { VueEditor } from 'vue2-editor'

export default {
  name: 'RichEditor',
  components: {
    VueEditor,
  },

  props: {
    remoteUpdateItem: {
      default: null,
      type: Function,
    },
    remoteGetItem: {
      default: null,
      type: Function,
    },
    checkContentValue: {
      default: null,
      type: Function,
    },
    disableButton: {
      type: Boolean,
    },
    liveMode :{
      type: Boolean,
      default: false,
    },
    currentData :{
      type: String,
      default: '',
    }

  },

  data() {
    return {
      content: '',
      recordId: 0,
    }
  },
  mounted() {
    if (this.remoteGetItem != null){
      this.getlist()
    } 
 
    if (this.currentData != ''){
      this.content = this.currentData
    } 
   
   
  },
  
  watch: {
    //  currentData(val) {
      // currentData(val) {
      //   this.content = val
      // }
    },
 
  methods: {
     
    getlist() {
      this.remoteGetItem({ page: 1, limit: 20, searchKeyWord: '' }).then(response => {
        this.content = response.data.record.content
        this.recordId = response.data.record.id
        this.checkContentValue(this.content)
      }).catch(err => {
        console.log('remoteGetItem', err)
      })
    },

    handleSavingContent() {
      this.remoteUpdateItem({ id: this.recordId, content: this.content }).then(response => {
        this.getlist()
      }).catch(err => {})
    },

  },

}
</script>

<style lang="scss">
  @import '@core/preset/preset/apps/user.scss';
  </style>

  <style scoped>
.center {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top : 12px;

}
  </style>
